export default class {
	constructor(obj) {
		this.id = obj.id
		this.code = obj.code
		this.beginDate = obj.creationdate
		this.endDate = obj.closedate
		this.updateDate = obj.updatedate
		this.xCoordinate = obj.xcoordinate
		this.yCoordinate = obj.ycoordinate
		this.comment = obj.comment
		this.status = obj.status
		this.supportCode = obj.supportcode
		this.methodId = obj.methodid
		this.natureId = obj.natureid
	}
}



// WEBPACK FOOTER //
// ./src/point/dto/DtoSamplingSurfacePoint.js